import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Тот же глиф, что profile-rounded-outline, но в полном 24-боксе с полями шрифта:
// нав-иконки обрезаны по глифу под таббар и в списках рядом с icomoon выглядят крупнее
export function AppIconProfileCircleOutline({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={fill}
        d="M20.0132 11.9998C20.0132 7.57384 16.4258 3.98637 11.9998 3.98637C7.57384 3.98637 3.98637 7.57384 3.98637 11.9998C3.98637 14.038 4.74797 15.8959 6.00218 17.3109C7.52359 15.8447 9.59525 14.9547 11.9998 14.9547C14.4041 14.9547 16.4749 15.8451 17.9962 17.3109C19.2508 15.8958 20.0132 14.0383 20.0132 11.9998ZM11.9998 17.1401C10.2498 17.1401 8.77359 17.7472 7.66937 18.7421C8.9183 19.5462 10.4033 20.0132 11.9998 20.0132C13.596 20.0132 15.0803 19.5459 16.3291 18.7421C15.2249 17.7476 13.7495 17.1401 11.9998 17.1401ZM22.1998 11.9998C22.1998 15.0837 20.8294 17.8494 18.6686 19.718C16.8811 21.2636 14.5482 22.1998 11.9998 22.1998C9.45136 22.1998 7.11847 21.2637 5.33103 19.718C3.17017 17.8494 1.7998 15.0837 1.7998 11.9998C1.7998 6.36676 6.36676 1.7998 11.9998 1.7998C17.6329 1.7998 22.1998 6.36677 22.1998 11.9998Z"
      />
      <Path
        fill={fill}
        d="M13.9421 9.97609C13.9421 8.90312 13.0728 8.0338 11.9998 8.0338C10.9268 8.0338 10.0575 8.90312 10.0575 9.97609C10.0575 11.0491 10.9268 11.9184 11.9998 11.9184C13.0728 11.9184 13.9421 11.0491 13.9421 9.97609ZM16.1287 9.97609C16.1287 12.2562 14.2799 14.1049 11.9998 14.1049C9.71972 14.1049 7.87095 12.2562 7.87095 9.97609C7.87095 7.69606 9.71971 5.84724 11.9998 5.84724C14.2799 5.84724 16.1287 7.69606 16.1287 9.97609Z"
      />
    </Svg>
  )
}
